

































import { Component, Vue } from 'vue-property-decorator'
import { OperationItemType } from '../../../types/type'
import html2canvas from 'html2canvas'
import { ElMessageComponent } from 'element-ui/types/message'
@Component({
  name: 'CapitalReceiptDetail',
  components: {
    'concise-card-have-title-acquiescent': () => import('../../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'capital-receipt-table': () => import('../../../components/capitalReceiptTable/index.vue')
  }
})
export default class CapitalReceiptDetail extends Vue {
  public tableDetail: any = {}
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public printForTableForCapitalReceiptTable: any = {
    id: 'capitalReceiptTable',
    popTitle: '', // 打印配置页上方标题
    extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
    preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
    previewBeforeOpenCallback () {
      // console.log('previewBeforeOpenCallback')
    }, // 预览窗口打开之前的callback（开启预览模式调用）
    previewOpenCallback () {
      // console.log('previewOpenCallback')
    }, // 预览窗口打开之后的callback（开启预览模式调用）
    beforeOpenCallback () {
      // console.log('beforeOpenCallback')
    }, // 开启打印前的回调事件
    openCallback () {
      // console.log('openCallback')
    }, // 调用打印之后的回调事件
    closeCallback () {
      // console.log('closeCallback')
    }, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
    url: '',
    standard: '',
    extraCss: ''
  }
  public loadingForCapitalReceiptContainer: boolean = false

  mounted () {
    setTimeout(() => {
      const capitalReceiptContainer = document.querySelector('.capital_receipt_container') as HTMLElement
      capitalReceiptContainer.classList.remove('animate__animated')
      capitalReceiptContainer.classList.remove('animate__backInUp')
    }, 1000)
    this.getCapitalReceiptDetail()
  }

  async getCapitalReceiptDetail () {
    try {
      this.loadingForCapitalReceiptContainer = true
      const { targetId, type } = this.$route.query
      const params = {
        targetId,
        type
      }
      const { data: result } = await (this as any).$http.capitalReceiptGet(params)
      this.loadingForCapitalReceiptContainer = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.tableDetail = result.data
    } catch (err) {
      console.log(err)
    }
  }

  downForTable (): ElMessageComponent | void {
    if (!this.tableDetail) return this.$message.error('抱歉，暂无数据！')
    this.$nextTick(async () => {
      this.loadingForCapitalReceiptContainer = true
      let _that: any = this
      let ele = document.querySelector('#capitalReceiptTable') as any
      let width = ele.offsetWidth
      let height = ele.offsetHeight
      let scale = 6
      const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft // 获取滚动轴滚动的长度
      const rect = ele.getBoundingClientRect() // 获取元素相对于视口的
      let canvas = await html2canvas(ele, {
        width,
        height,
        scale,
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true, // 允许跨域图片
        logging: false,
        x: rect.left, // 绘制的dom元素相对于视口的位置
        y: rect.top,
        scrollX: -scrollLeft, // 滚动的长度
        scrollY: 0
      })
      let imgUrl = canvas.toDataURL('image/png')
      // 下载：
      var eleLink = document.createElement('a')
      eleLink.href = imgUrl // 转换后的图片地址
      eleLink.download = `《收据单》(${this.tableDetail.reNumber ? this.tableDetail.reNumber : ''}).png`
      document.body.appendChild(eleLink)
      eleLink.click()
      document.body.removeChild(eleLink)
      _that.$message.success('下载成功')
      this.loadingForCapitalReceiptContainer = false
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row, uploadFile?: File) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
    }
  }
}
